import React from "react";
import { useParams } from "react-router-dom";
import FormPollResults from "../components/polls/FormPollResults";

/**
 * Vue EMBED des résultats — version nue pour iframe (Phase 6). FormPollResults
 * applique useResultsAccess : les résultats ne s'affichent en embed que si la
 * visibilité est "public" (sinon écran d'accès restreint), donc pas de fuite.
 */
export default function EmbedResults() {
  const { slug } = useParams<{ slug: string }>();
  return (
    <div className="min-h-screen bg-white">
      <FormPollResults idOrSlug={slug!} />
    </div>
  );
}
